import React from "react";

const TabsView = ({ categories, activeCategoryIndex }) => (
  <>
    {categories.map((category, index) => (
      <div
        key={index}
        className="blog-category">
        <a
          className={`${index === activeCategoryIndex ? 'active' : ''}`}
          href={category.href}
          dangerouslySetInnerHTML={{ __html: category.content }}
        />
      </div>
    ))}
  </>
);

export default TabsView;
